import React from 'react'

import { API } from 'services';
import { Auth } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicHorseListScene } from 'scenes';

class ClinicHorseListContainer extends AbstractContainer {

  getTasks() {

    let clinic = Auth.getManagedClinic();

    return [
      {
        key: 'horses',
        exec: (done, failure) => {
          API.get(`/clinics/${clinic.id}/horses`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicHorseListScene horses={results.horses} />
  }
}

export default ClinicHorseListContainer;
